import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getIndiceValorGraficos(): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/indice_valor/graficos/', {});
  return data;
}

type QueryFnType = typeof getIndiceValorGraficos;

function useIndiceValorGraficos() {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-indice-valor-graficos'],
    queryFn: getIndiceValorGraficos,
  });
}

export { getIndiceValorGraficos, useIndiceValorGraficos };
